<div class="zag-team-members-preview">
  @if (loading()) {
    <p class="zag-team-members-preview__loading-label" role="status">
      {{ 'common.team.membersPreview.loading' | translate }}
    </p>
    <div class="zag-team-members-preview__skeleton-list" aria-hidden="true">
      @for (index of skeletonRows; track index) {
        <div class="zag-team-members-preview__skeleton-row"></div>
      }
    </div>
  } @else if (loadError()) {
    <p class="zag-team-members-preview__error" role="alert">{{ 'common.team.membersPreview.error' | translate }}</p>
  } @else if (rows().length === 0) {
    <p class="zag-team-members-preview__empty">{{ 'teams.persons.empty' | translate }}</p>
  } @else {
    <ul class="zag-team-members-preview__list">
      @for (row of rows(); track row.personId) {
        <li class="zag-team-members-preview__row">
          <zag-avatar [name]="row.displayName" [src]="row.avatarUrl" size="xs" />
          <span class="zag-team-members-preview__name">{{ row.displayName }}</span>
          <zag-badge color="neutral">{{ roleLabelKey(row.role) | translate }}</zag-badge>
        </li>
      }
    </ul>
  }
</div>
